import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { trackAndRedirect } from '../utils/metaPixel';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const heroHeight = window.innerHeight * 0.85;
      const pricingEl = document.getElementById('pricing');
      let pastPricing = false;
      if (pricingEl) {
        const rect = pricingEl.getBoundingClientRect();
        pastPricing = rect.top < window.innerHeight && rect.bottom > 0;
      }
      setIsVisible(scrollY > heroHeight && !pastPricing);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-400 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0 pointer-events-none'}`} data-id="element-299">
      <div className="bg-navy-900/95 backdrop-blur-sm border-t border-navy-700 px-4 py-3" data-id="element-300">
        <div className="max-w-xl mx-auto flex items-center justify-between gap-4" data-id="element-301">
          <div className="hidden sm:flex items-center gap-3" data-id="element-302">
            <span className="text-gray-500 text-sm line-through" data-id="element-303">$144</span>
            <span className="text-white text-2xl font-bold" data-id="element-304">$6.36</span>
            <span className="bg-teal-600 text-white text-xs font-bold px-2 py-0.5 rounded-full uppercase" data-id="element-305">
              96% off
            </span>
          </div>
          <div className="sm:hidden flex items-center gap-2" data-id="element-306">
            <span className="text-white text-xl font-bold" data-id="element-307">$6.36</span>
            <span className="bg-teal-600 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-308">
              96% off
            </span>
          </div>
          <a href="#pricing" onClick={e => {
          e.preventDefault();
          const el = document.getElementById('pricing');
          if (el) {
            const start = window.scrollY;
            const end = el.getBoundingClientRect().top + window.scrollY - 20;
            const duration = 1500;
            let startTime: number | null = null;
            const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            const animate = (currentTime: number) => {
              if (!startTime) startTime = currentTime;
              const elapsed = currentTime - startTime;
              const progress = Math.min(elapsed / duration, 1);
              window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
              if (progress < 1) requestAnimationFrame(animate);
            };
            requestAnimationFrame(animate);
          }
        }} className="inline-flex items-center justify-center px-6 py-3 text-sm sm:text-base font-bold text-white bg-amber-500 rounded-lg hover:bg-amber-600 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200 whitespace-nowrap" data-id="element-309">
            Get the Plan
            <ArrowRight className="ml-2 h-4 w-4" data-id="element-310" />
          </a>
        </div>
      </div>
    </div>;
}